<!--
 * @Descripttion: 
 * @version: 
 * @Author: zhouxh
 * @Date: 2023-05-26 09:26:18
-->
<template>
    <div class="supplier-container">
  
      <div class="submenu-wrapper">
        <Submenu 
        :engLabel="englabel"
        :cnLabel="cnLabel"
        :linkData="linkData"
      />
      </div>
  
      <div class="main-wrapper py-2 py-md-5 px-2">
          <!-- 主要供应商 -->
          <div class="img-wrapper">
          <p class="split-header">主要供应商</p>
          <div class="row justify-content-center">
            <div class="col-12 col-xl-10">
              <ImageLoader 
                :src="img"
                :height="imgHeight"
                fit="fill"
                />
            </div> 
         </div>
        </div>
  
      </div>
  
    </div>
  </template>
  
  <script>
  import { ProductLink } from "@/assets/js/submenulink.js";
  import Submenu from "@/components/Submenu/";
  import ImageLoader from "@/components/ImageLoader/";
  export default {
     components: {
      Submenu,
      ImageLoader,
     },
    
     data() {
        return {
          englabel: 'PRODUCT',
          cnLabel: '产品',
          imgHeight: 568,
          img_aspect_ratio: (958 / 552).toFixed(2),
          windowSize: {},
          linkData: [],
          img: require("@/assets/img/Product/supplier.png"),

        }
    },
  
    created() {
        this.getWindowSize();
        this.linkData = ProductLink;
     },

  
    mounted() {
        //拉伸窗口时触发
        window.onresize = () => {
            this.getWindowSize();
            
        }
  
    },
     methods: {
      getWindowSize() {
           this.windowSize.width =   document.documentElement.clientWidth || document.body.clientWidth; 
           this.windowSize.Height =  document.documentElement.clientHeight || document.body.clientHeight; 
           this.imgHeight = Math.round(this.windowSize.width / this.img_aspect_ratio); 
        },
     }
  
  
  }
  </script>
  
  <style scoped lang="less">
  @import "~@/styles/global.less";
  @import "~@/styles/mixin.less";
    .supplier-container{
      position: relative;;
      width: 100%;;
      height: auto;
      .general-layout;

    }
  
  </style>